import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import {get, post} from 'bukku/shared/ApiService';

// Read action
export function* readAllActionRequest() {
    yield takeEvery(actions.READ_ALL_ACTION_REQUEST, function* ({request}, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/admin/commands`, request, context);
            const data = yield response.data;

            yield put({
                type: actions.READ_ALL_ACTION_SUCCESS,
                config: data,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_ALL_ACTION_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readAllActionSuccess() {
    yield takeEvery(actions.READ_ALL_ACTION_SUCCESS, () => {});
}
export function* readAllActionError() {
    yield takeEvery(actions.READ_ALL_ACTION_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Dynamic Action
export function* dynamicActionRequest() {
    yield takeEvery(actions.DYNAMIC_ACTION_REQUEST, function* ({payloads, config }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(post, '/admin/commands/run', payloads, context);
            const data = yield response.data;
            yield put({
                type: actions.DYNAMIC_ACTION_SUCCESS,
                responseMessage: data.message,
                config,
            });
        }
        catch (error) {
            yield put({
                type: actions.DYNAMIC_ACTION_ERROR,
                responseMessage: error.message,
                config,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}

export default function* rootSaga() {
    yield all([
        fork(readAllActionRequest),
        fork(readAllActionSuccess),
        fork(readAllActionError),
        fork(dynamicActionRequest),
    ]);
}
